import React, { createContext, useContext, useState, useEffect } from 'react';
import { getFeatureStatus } from '../services/firebase';

// Create the context
const FeatureContext = createContext();

// Custom hook to use the feature context
export const useFeature = () => {
  return useContext(FeatureContext);
};

// Provider component
export const FeatureProvider = ({ children }) => {
  const [features, setFeatures] = useState({
    'youtube-reel': true,
    'form-connect': true,
    'social-media-content': true,
    'digital-identity': true
  });
  const [loading, setLoading] = useState(true);

  // Load feature status on mount
  useEffect(() => {
    const loadFeatureStatus = async () => {
      try {
        const featureIds = ['youtube-reel', 'form-connect', 'social-media-content', 'digital-identity'];
        const featureStatus = {};
        
        // Load status for each feature
        for (const featureId of featureIds) {
          featureStatus[featureId] = await getFeatureStatus(featureId);
        }
        
        setFeatures(featureStatus);
      } catch (error) {
        console.error('Error loading feature status:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadFeatureStatus();
  }, []);

  // Check if a feature is enabled
  const isFeatureEnabled = (featureId) => {
    return features[featureId] === true;
  };

  // Value to be provided to consumers
  const value = {
    features,
    isFeatureEnabled,
    loading
  };

  return (
    <FeatureContext.Provider value={value}>
      {children}
    </FeatureContext.Provider>
  );
};
